import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminFileGet, DistributionTariffGasGet, GasTaxGet } from '../interfaces/file-management-interfaces';
import { API_ROUTES } from './api-routes';
import { FileDownload } from '../interfaces/file-upload-interfaces';

@Injectable({
  providedIn: 'root'
})
export class FileManagementService {
  constructor(private http: HttpClient) { }

  downloadFile(file_id: string): Observable<any> {
    return this.http.get<FileDownload>(
      `${API_ROUTES.FILES_MANAGEMENT.DOWNLOAD}/${file_id}`,
    );
  }

  // Gas Taxes
  uploadGasTaxes(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<AdminFileGet>(
      `${API_ROUTES.FILES_MANAGEMENT.UPLOAD_GAS_TAXES}`,
      formData,
      { reportProgress: true, observe: 'events' }
    );
  }

  getGasTaxes(): Observable<AdminFileGet[]> {
    return this.http.get<AdminFileGet[]>(
      `${API_ROUTES.FILES_MANAGEMENT.GET_GAS_TAXES}`,
    );
  }

  // Gas Distribution Tariff
  uploadGasDistributionTariff(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<AdminFileGet>(
      `${API_ROUTES.FILES_MANAGEMENT.UPLOAD_GAS_DISTRIBUTION_TARIFF}`,
      formData,
      { reportProgress: true, observe: 'events' }
    );
  }

  getGasDistributionTariffs(): Observable<AdminFileGet[]> {
    return this.http.get<AdminFileGet[]>(
      `${API_ROUTES.FILES_MANAGEMENT.GET_GAS_DISTRIBUTION_TARIFF}`,
    );
  }

  // Accise Gas
  uploadAcciseGas(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<AdminFileGet>(
      `${API_ROUTES.FILES_MANAGEMENT.UPLOAD_ACCISE_GAS}`,
      formData,
      { reportProgress: true, observe: 'events' }
    );
  }

  getAcciseGas(): Observable<AdminFileGet[]> {
    return this.http.get<AdminFileGet[]>(
      `${API_ROUTES.FILES_MANAGEMENT.GET_ACCISE_GAS}`,
    );
  }

  // Electricity And Gas Prices
  uploadElectricityAndGasPrices(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post<AdminFileGet>(
      `${API_ROUTES.FILES_MANAGEMENT.UPLOAD_ELECTRICITY_AND_GAS_PRICES}`,
      formData,
      { reportProgress: true, observe: 'events' }
    );
  }

  getElectricityAndGasPrices(): Observable<AdminFileGet[]> {
    return this.http.get<AdminFileGet[]>(
      `${API_ROUTES.FILES_MANAGEMENT.GET_ELECTRICITY_AND_GAS_PRICES}`,
    );
  }
}
